/* Logic for managing user account */

import { get_or_set, get } from './preferences'
import {rando} from '@nastyox/rando.js';
import Clarity from '@microsoft/clarity';
import { base_domain } from './backend'

const base_url = `${base_domain}/api/`

const state = {
  session_id: 'not_set'
}

export async function init() {
    const user_id = await get_or_set("user_id", new Date().toISOString())
    const user_key = await get_or_set("user_key", gen_key())

    // for tracking
    state.session_id = new Date().toISOString();
    
    // login!
    await fetch(base_url + "accounts", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id, user_key })
    })
}

 // helpers

function randomString(length: number, characters: string): string {
  let str = "";
  for (let i = 0; i < length; i++) {
    str += rando(characters);
  }
  return str;
}

function gen_key(): string {
    return randomString(32, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789");
}

export async function track() {
  const customId = await get("user_id")

  Clarity.identify(customId, state.session_id, window.location.href, customId);
}

export default { init }
